import { Users, auth, storage } from '@/firebase'
import { USER, ERROR, ACCOUNT, COMMAND } from "./actions.type";

const state = {
  profile: null,
  credential: null
};

const mutations = {
  [USER.SET](state, user) {
    state.profile = user;
  },
  [USER.SETAUTH](state, fbCredential) {
    state.credential = fbCredential;
  },
};


const getters = {
  currentUser(state) {
    return state.profile;
  },
  credential(state) {
    return state.credential;
  },
  isAuthenticated(state) {
    if (state.credential) {
      return true
    } else {
      return false
    }

  }
};

const actions = {
  async [USER.AUTH](context) {
    // fetch user profile
    await auth.onAuthStateChanged(user => {
      if (user.uid) {
        context.commit(USER.SETAUTH, user)
        context.dispatch(USER.GET, user)
        return user
      } else {
        return false
      }
    })
    // set user profile in state

  },
  async [USER.LOGIN](context, credentials) {
    auth.signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        context.dispatch(USER.AUTH)
      })
      .catch(errors => {
        context.dispatch(ERROR.SET, errors.message)
      })
  },
  async [USER.LOGOUT](context) {
    auth.signOut()
      .then(() => {
        context.commit(USER.SET, null)
        context.commit(USER.SETAUTH, null)
        context.commit(ACCOUNT.SET, null)
        context.commit(COMMAND.SET, null)
        context.dispatch(ERROR.SET, 'logged out....')
      })
      .catch(errors => {
        context.dispatch(ERROR.SET, errors.message)
      })

  },
  async [USER.GET](context, user) {
    // fetch user profile
    const userProfile = await Users.doc(user.uid).get()
    // set user profile in state
    context.commit(USER.SET, userProfile.data())
    return userProfile.data()

  },
  async [USER.GETBASIC](context, userId) {
    // fetch user profile
    const userProfile = await Users.doc(userId).get()
    // console.log(userProfile.data())
    // delete userProfile.id 
    // console.log(userProfile.data())
    return userProfile.data()

  },
  async [USER.ISVALID_USERNAME](context, username) {
    const users = await Users.where('username', '==', username).get();
    if (users.empty) {
      console.log('No matching documents.');
      return true;
    } else {
      return false
    }
  },
  async [USER.REGISTER](context, schema) {
    // sign user up
    const { user } = await auth.createUserWithEmailAndPassword(schema.email, schema.password)
      .catch(error => {
        context.commit(ERROR.SET, error.message);
      });
    context.dispatch(USER.CREATE, user)
    context.dispatch(USER.SET, user)
  },
  async [USER.CREATE](context, user) {
    const userInfo = {
      displayName: user.displayName
        ? user.displayName
        : user.email.split("@")[0],
      email: user.email,
      emailVerified: user.emailVerified,
      phoneNumber: user.phoneNumber,
      photoURL: user.photoURL,
      userId: user.uid,
      id: user.id,
      providerData: user.providerData,
      refreshToken: user.refreshToken,
      // accessToken: accessToken
    }
    const userProfile = await Users.doc(user.uid).set(userInfo)
    context.dispatch(USER.SET, userProfile)
  },

  async [USER.UPDATE](context, credentials) {
    // update 
    // const credentials = schema
    // credentials.displayName = schema.username
    // delete credentials.username

    var user = auth.currentUser;
    if (credentials.username || credentials.photoURL)
      user
        .updateProfile({
          displayName: credentials.username
            ? credentials.username
            : user.displayName,
          photoURL: credentials.photoURL
            ? credentials.photoURL
            : user.photoURL
        })
        .then(async function () {
          await Users.doc(user.uid).update(credentials)
            .then(async () => {
              // update must be await to update newsest value
              await context.dispatch(USER.GET, user)
                .then(() => context.commit(ERROR.SET, 'updated!'))

            }
            )
            .catch(error => {
              context.commit(ERROR.SET, error.message);
            });
        })
        .catch(function (error) {
          context.commit(ERROR.SET, error.message);
        });
    // reset password
    if (credentials.password) {
      user
        .updatePassword(credentials.password)
        .then(function () {
          // force to logout
          context.commit(USER.LOGOUT);
        })
        .catch(function (error) {
          context.commit(ERROR.SET, error.message);
        });
    }
    // update

  },



  async[USER.UPLOAD_AVATAR](context, payload) {
    // console.log(payload);
    const extension = payload.avatarFile.name.split(".")[1];
    const path = `users/${payload.userId}/avatar/avatar.${extension}`;

    // Create a root reference
    var storageRef = storage.ref();
    var avatarRef = storageRef.child(path);
    var uploadTask = avatarRef.put(payload.avatarFile);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on(
      "state_changed",
      function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        // var progress =
        //   (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case storage.TaskState.PAUSED: // or 'paused'
            // console.log("Upload is paused");
            break;
          case storage.TaskState.RUNNING: // or 'running'
            // console.log("Upload is running");
            break;
        }
      },
      function (error) {
        // console.log(error);
        context.commit(ERROR.SET, error.message);
        // Handle unsuccessful uploads
      },
      function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          // update user
          context.dispatch(USER.UPDATE, {
            photoURL: downloadURL
          })
        });
      }
    );

  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
